import styled from 'styled-components';
import { VideoPlayer } from '../../videoPlayer';

const platformSizes = {
  desktopFull: {
    height: 610,
    width: 1085,
  },
  desktop: {
    height: 610,
    width: 1085,
  },
  mobile: {
    height: 200,
    width: 360,
  },
};

export const Player = styled(VideoPlayer)`
  display: flex !important;
  justify-content: space-around;
  max-width: 100%;
  position: relative;

  &.player--desktopFull {
    width: ${platformSizes.desktopFull.width}px;
    height: ${platformSizes.desktopFull.height}px;
    iframe {
      height: 100%;
      width: 100%;
    }
  }

  &.player--desktop {
    width: ${platformSizes.desktop.width}px;
    height: ${platformSizes.desktop.height}px;
  }

  &.player--mobile {
    width: ${platformSizes.mobile.width}px;
    height: ${platformSizes.mobile.height}px;
    iframe {
      min-height: 150px;
      min-width: 300px;
    }
  }

  iframe {
    min-height: 360px;
    min-width: 640px;
    max-height: 100%;
    max-width: 100%;
    height: 100%;
    width: 100%;
  }
`;
